import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../services/storage.service';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Network } from '@ngx-pwa/offline';
import { GlobalService } from '../services/global.service';
import { AuthFacade } from '../ngrx/auth/auth.facade';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  alerts: any[] = [];
  displayForIOS: boolean;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private storage: StorageService,
    private network: Network,
    private authFacade: AuthFacade,
    private global: GlobalService
  ) {
  }

  ngOnInit() {
    this.global.deleteExpiredData();
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = navigator.platform.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent ) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator as any).standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.displayForIOS = true;
    }
    console.log('isIos()', isIos());
    console.log('isInStandaloneMode()', !isInStandaloneMode());
  }

  processLogin() {
    this.router.navigate(['report-list']);
  }

  login() {
    const payload = {
      username: this.username,
      password: this.password,
      grant_type: 'password'
    };

    if (this.password === '' || this.username === '') {
      this.alerts.push({
        type: 'danger',
        msg: 'Username and Password are required!',
        timeout: 5000
      });
      return;
    }

    this.authService.processLogin(payload).subscribe(data => {
      this.global.deleteExpiredData();
      if (data.error !== undefined) {
        this.alerts.push({
          type: 'danger',
          msg: data.error.error_description !== undefined ? data.error.error_description : 'Network Error!',
          timeout: 5000
        });
      } else {
        this.authFacade.insertDataToDB(data);
        this.storage.setLocalValue('selectedAssignedAgentId', data.agent_id);
        this.storage.setLocalValue('selectedAssignedAgentUserName', this.username);
        this.storage.setLocalValue('selectedAssignedAgentLastName', data.last_name);
        this.storage.setLocalValue('selectedAssignedAgentFirstName', data.first_name);
        setTimeout(() => { this.router.navigate(['report-list']); }, 500);
      }
    });
  }

  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

}
